import styled from "@emotion/styled/macro";
import React, {PropsWithChildren} from "react";


const SwitchDiv = styled.div`

  
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  
  circle {
    transition: linear 0.1s;
  }
    &.checked circle {
      transform: translate(20px);
    }
  
  &.unchecked circle {
    fill: #fafafa;
  }
 
`
const Switch: React.FC<PropsWithChildren<{checked: boolean, onChange: (checked: boolean) => void}>> = (props) => {
    const {checked, children, onChange} = props;
    return <SwitchDiv onClick={() => onChange(!checked)} className={checked ? "checked" : "unchecked"}><svg width="58" height="39" viewBox="0 0 58 39" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.38">
            <rect x="12" y="12.5" width="34" height="14" rx="7" fill="#565755"/>
        </g>
        <g filter="url(#filter0_ddd_2111_15200)">
            <circle cx="19" cy="19.5" r="10" fill="#185A7D"/>
        </g>
        <defs>
            {/* Note - I manually changed the filter width from Figma to 52 (from default 26) */ }
            <filter id="filter0_ddd_2111_15200" x="0" y="7.5" width="52" height="26" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="1"/>
                <feGaussianBlur stdDeviation="1.5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"/>
                <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2111_15200"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dy="1"/>
                <feGaussianBlur stdDeviation="0.5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"/>
                <feBlend mode="normal" in2="effect1_dropShadow_2111_15200" result="effect2_dropShadow_2111_15200"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feMorphology radius="1" operator="erode" in="SourceAlpha" result="effect3_dropShadow_2111_15200"/>
                <feOffset dy="2"/>
                <feGaussianBlur stdDeviation="0.5"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
                <feBlend mode="normal" in2="effect2_dropShadow_2111_15200" result="effect3_dropShadow_2111_15200"/>
                <feBlend mode="normal" in="SourceGraphic" in2="effect3_dropShadow_2111_15200" result="shape"/>
            </filter>
        </defs>
    </svg>
        { children }
    </SwitchDiv>

}
export default Switch;